<template>
  <div class="viewport viewport-with-bottom-nav viewport-compact">
    <pull-refresh :on-refresh="onRefresh">
      <div class="display-1 py-3">{{$t('LoansPage.title')}}</div>
      <template v-if="loading">
        <LoanCardSkeleton></LoanCardSkeleton>
        <LoanCardSkeleton></LoanCardSkeleton>
      </template>
      <template v-else>
        <LoansList :loans="loans" :pending-applications="pendingApplications"
                   :applications-history="applicationsHistory"
                   :showFullDetailsForWrittenOff="showFullDetailsForWrittenOff"
                   show-status-name="true"></LoansList>
      </template>
    </pull-refresh>
    <div class="flex-grow-1"></div>
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import store from '@shared/store'
import LoansList from '@shared/components/LoansList'
import LoanCardSkeleton from '@shared/components/LoanCardSkeleton'
import PullRefresh from '@shared/components/PullRefresh'
import CacheMixin from '@shared/mixins/CacheMixin'
import BottomNav from '../components/BottomNav'

export default {
    name: 'LoansPage',
    components: { BottomNav, LoanCardSkeleton, LoansList, PullRefresh },
    props: ['showFullDetailsForWrittenOff'],
    data () {
      return {
        loading: true,
        loans: [],
        pendingApplications: [],
        applicationsHistory: [],
        state: store.state
      }
    },
    mixins: [CacheMixin],
    methods: {
      onRefresh() {
        this.loading = true
        return this.resetCache().then(() => this.loadData())
      },
      loadData() {
        return this.$http.get(`/api/customers/${this.state.currentUser.pin}/loans/history`).then(response => {
          this.pendingApplications = response.data.pendingApplications || []
          this.applicationsHistory = response.data.applicationsHistory || []
          this.loans = response.data.loans || []
          this.loading = false
        })
      }
    },
    mounted () {
      this.loadData()
    }
  }
</script>
